<template>
    <div>
        <report-header
            :title="title"
            :isShowDateRange="true"
            :formatDateRangeTitle="dateRange"
        />
        <b-card id="report-card pb-4">
            <loader-barchart
                v-if="isLoading"
                class="graph-overlay"
                style="height: 450px; margin: 2em 0px 2em 20px;"
                :styles="'height: 450px'"
            />
            <div
                id="total-patients-chart"
                style="height: 450px; margin: 2em 0px 2em 20px;"
            ></div>
            <div id="legendContainer" class="justify-center flex"></div>
        </b-card>
    </div>
</template>
<script>
import "@/jquery/jquery.flot.tooltip";
import "@/jquery/jquery.flot.stack";
import "@/css/quasar-table.css";
import Report from "@/mixins/report.js";
import ReportService from "@/services/report";
import CREPORT from "@/constants/report";
import { maxBy } from "lodash";
export default {
    mixins: [Report],
    components: {
        LoaderBarchart: () => import("@/components/elements/loader-barchart"),
        ReportHeader: () => import("@/components/report/report-header")
    },
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: this.getInitalMonthChart(),
                    end: this.getEndDate("month"),
                    datePickerOptions: {
                        format: this.datepickerMonthFormat
                    }
                };
            }
        }
    },
    data() {
        return {
            isLoading: true,
            isError: false,
            dateRange: "",
            title: "Total Patients",
            dataGraph: {},
            options: {}
        };
    },
    async mounted() {
        let self = this;
        self.data.isShowDateRange = true;
        self.data.datePickerOptions.format = self.datepickerMonthFormat;
        self.data.isFilterDateMonthOnly = true;
        self.data.datePickerOptionDefault = 1;
        self.data.exportOptionCsvOnly = true;

        self._getSetting().then(() => {
            self.data.start = self.getInitalMonthChart();
            self.data.end = self.getEndDate("month");
            self.data.from = self.converToUnix(self.data.start);
            self.data.to = self.converToUnix(self.data.end);
            self.init();
        });

        self.$root.$on("report-filter-date-range:refresh", this.init);
        window.scrollTo(0, 0);
    },
    beforeDestroy: function () {
        this.data.datePickerOptions.format = this.getDateFormat();
        this.data.isFilterDateMonthOnly = false;
        this.data.datePickerOptionDefault = null;
        this.data.exportOptionCsvOnly = false;
        this.$root.$off("report-filter-date-range:refresh", this.init);
    },
    methods: {
        endDate() {
            return moment().tz(this._timeZone).endOf("month");
        },
        async init(params) {
            let self = this;
            self.isLoading = true;
            self.isError = false;

            if (params) {
                self.data.from = params.from;
                self.data.to = params.to;
            }
            self.dateRange = self.getDateRange(
                self.data.from,
                self.data.to,
                self.formatInMonth
            );

            await ReportService.getReport(CREPORT.TYPE.TOTAL_PATIENTS, {
                from: self.data.from,
                to: self.data.to
            })
                .then(res => {
                    if (res && res.message && res.message.code === 200) {
                        self.dynamicPageTitle(self.title);
                        self.renderGraph(res.resource.results.data);
                        self.dateRange = self.getDateRange(
                            res.resource.results.from,
                            res.resource.results.to,
                            self.formatInMonth
                        );
                    } else {
                        throw new Error("Error: Unable to get the report.");
                    }
                })
                .catch(e => {
                    console.error(e);
                    self.isLoading = false;
                    self.isError = true;
                    // DEFAULT CHART AND TABLE WHEN SOMETHING WRONG
                    self.renderGraph([
                        {
                            active: 0,
                            date: "Month",
                            deceased: 0,
                            inactive: 0,
                            total: 0
                        }
                    ]);
                    self._message("Error: Unable to get the report", "danger");
                })
                .finally(() => {
                    self.isLoading = false;
                });
        },
        renderGraph(results) {
            let xaxisLabel = [];
            let self = this;
            let dataActive = [];
            let dataInactive = [];
            let dataDeceased = [];
            let i = 1;
            xaxisLabel;
            let tickSize = 1;
            if (results.length > 0) {
                results.forEach(result => {
                    dataActive.push([i, result.active || 0]);
                    dataInactive.push([i, result.inactive || 0]);
                    dataDeceased.push([i, result.deceased || 0]);
                    xaxisLabel.push([i, result.date]);
                    i++;
                });

                let resultMax = maxBy(results, "total");
                tickSize = Math.round(resultMax.total) / 10; // to 10 ticks
                tickSize = Math.ceil(tickSize / 10) * 10; // round to neareset 10
            }

            self.dataGraph = [
                {
                    label: "Active",
                    data: dataActive,
                    color: "#bce381"
                },
                {
                    label: "Inactive",
                    data: dataInactive,
                    color: "#e4e841"
                },
                {
                    label: "Deceased",
                    data: dataDeceased,
                    color: "#E06666"
                }
            ];

            var legendContainer = document.getElementById("legendContainer");
            var legendSettings = {
                position: "nw",
                show: true,
                noColumns: 3,
                container: legendContainer
            };
            self.options = {
                legend: legendSettings,
                series: {
                    stack: 0,
                    lines: {
                        show: false,
                        fill: true,
                        steps: false
                    },
                    bars: {
                        show: true,
                        barWidth: 0.9,
                        align: "center",
                        lineWidth: 0,
                        fillColor: {
                            colors: [{ opacity: 0.8 }, { opacity: 0.8 }]
                        }
                    },
                    points: {
                        show: false
                    }
                },
                grid: {
                    borderWidth: 0,
                    hoverable: true
                },
                xaxis: {
                    ticks: xaxisLabel
                },
                yaxis: {
                    axisLabel: "",
                    axisLabelUseCanvas: false,
                    tickDecimals: 0,
                    tickSize: tickSize,
                    tickFormatter: function numberWithCommas(x) {
                        return x
                            .toString()
                            .replace(/\B(?=(?:\d{3})+(?!\d))/g, ",");
                    }
                },
                tooltip: true,
                tooltipOpts: {
                    content: function (label, xval, yval, flotItem) {
                        return `${label} (${yval})`;
                    },
                    shifts: {
                        x: 20,
                        y: 0
                    },
                    defaultTheme: false
                }
            };

            $.plot($("#total-patients-chart"), self.dataGraph, self.options);
            $(window).resize(function () {
                if (
                    self.$router.history.current.path ==
                    "/report/" + CREPORT.TYPE.TOTAL_PATIENTS
                ) {
                    $.plot(
                        $("#total-patients-chart"),
                        self.dataGraph,
                        self.options
                    );
                }
            });
        }
    }
};
</script>
<style>
.graph-overlay {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    z-index: 2;
    cursor: pointer;
}
</style>
